import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useSsmConfigBridge } from '@utilities/hooks/useSsmConfigBridge/useSsmConfigBridge';
import { useMessageController } from '@utilities/hooks/useMessageController/useMessageController';
import { WEEK_VIEW_URL } from '@utilities/constants';

export const WeekViewPage: React.FC = () => {
	const iframeRef = React.useRef<HTMLIFrameElement>(null);
	const controller = useMessageController(iframeRef, {
		targetOrigin: new URL(window.config.UI_SHELL_URL).origin,
	});

	useSsmConfigBridge(controller);

	return (
		<Box p={3}>
			<Typography variant="h4" gutterBottom>
				Weekly Calendar
			</Typography>
			<iframe ref={iframeRef} title="Weekly Calendar Page" src={WEEK_VIEW_URL} />
		</Box>
	);
};
